import React from 'react';
import { ControlledAbTestingProvider } from './Controlled.js';
import { UncontrolledAbTestingProvider } from './Uncontrolled.js';
export { AbTestingContext } from './Context.js';

/**
 * @description AB testing context provider component.
 *
 * @component
 * @example
 * ```jsx
 * <AbTestingProvider initialValue={****}>content</AbTestingProvider>
 * ```
 */
function AbTestingProvider(props) {
    const { mode = 'uncontrolled', children } = props;
    const isControlled = mode === 'controlled';
    if (isControlled) {
        const { value } = props;
        return React.createElement(ControlledAbTestingProvider, { value: value }, children);
    }
    const { initialValue } = props;
    return React.createElement(UncontrolledAbTestingProvider, { initialValue: initialValue }, children);
}

export { AbTestingProvider };
//# sourceMappingURL=index.js.map
